import filterBar from './filterBar';
export default filterBar;



// WEBPACK FOOTER //
// ./src/components/filterBar/index.js